/**
 * @generated SignedSource<<dcffeab4387028fa9df04e5285fbad00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTimeRegInput = {
  taskId?: string | null;
  idleTimeId?: string | null;
  projectId?: string | null;
  year?: number | null;
  month?: number | null;
  day?: number | null;
  minutesRegistered?: number | null;
  billableMinutesRegistered?: number | null;
  harvestTaskId?: string | null;
  unit4ActivityId?: string | null;
  unit4ActivityName?: string | null;
  personId?: string | null;
  roleId?: string | null;
  billable?: boolean | null;
  notes?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createTimeRegMutation$variables = {
  input: CreateTimeRegInput;
};
export type createTimeRegMutation$data = {
  readonly createTimeReg: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly task: {
      readonly id: string;
      readonly totalMinutesRegistered: number | null;
    } | null;
  } | null;
};
export type createTimeRegMutation = {
  variables: createTimeRegMutation$variables;
  response: createTimeRegMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTimeRegPayload",
    "kind": "LinkedField",
    "name": "createTimeReg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMinutesRegistered",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTimeRegMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTimeRegMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6db26a16c0f2bec5c557925ee73613f",
    "id": null,
    "metadata": {},
    "name": "createTimeRegMutation",
    "operationKind": "mutation",
    "text": "mutation createTimeRegMutation(\n  $input: CreateTimeRegInput!\n) {\n  createTimeReg(input: $input) {\n    errors\n    task {\n      id\n      totalMinutesRegistered\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bfcb25d848a7e7d9aac766c9c516836";

export default node;
